(function () {
  const sentinel = document.querySelector('[data-infinite-scroll]');
  if (!sentinel) return;

  const grid = document.querySelector('[data-products-grid]');
  if (!grid) return;

  const loader = document.querySelector('.infinite-scroll-loader');
  const trigger = document.querySelector('.infinite-scroll-trigger');
  const button = document.querySelector('[data-load-more]');

  if (!button) return;

  button.addEventListener('click', async function () {
    const nextUrl = sentinel.getAttribute('data-next-url');
    if (!nextUrl) return;

    button.disabled = true;
    if (loader) loader.hidden = false;

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      doc.querySelectorAll('[data-products-grid] > li').forEach(function (item) {
        grid.appendChild(item);
      });

      if (typeof window.initImageLoad === 'function') window.initImageLoad();

      const nextSentinel = doc.querySelector('[data-infinite-scroll]');
      const newNextUrl = nextSentinel ? nextSentinel.getAttribute('data-next-url') : '';
      sentinel.setAttribute('data-next-url', newNextUrl);

      if (newNextUrl) {
        button.disabled = false;
      } else {
        if (trigger) trigger.hidden = true;
      }
    } catch (e) {
      console.error('[load-more] fetch failed', e);
      button.disabled = false;
    }

    if (loader) loader.hidden = true;
  });
})();
